import React from 'react';
import { Youtube } from 'lucide-react';

export default function YouTubeCallToAction() {
  const scrollToGenerator = () => {
    document.getElementById('youtube-generator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-red-600">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex justify-center mb-6">
          <Youtube className="w-12 h-12 text-red-200" />
        </div>
        <h2 className="text-3xl font-bold text-white mb-4">
          Ready to Optimize Your YouTube Videos?
        </h2>
        <p className="text-xl text-red-100 mb-8">
          Join thousands of content creators who use our tag generator to increase their video visibility.
        </p>
        <button 
          onClick={scrollToGenerator}
          className="bg-white text-red-600 text-lg px-8 py-4 rounded-lg hover:bg-red-50 transition-colors cursor-pointer shadow-lg hover:shadow-xl"
        >
          Generate Tags Now!
        </button>
        <p className="mt-6 text-sm text-red-200">
          Perfect for creators of all types and sizes
        </p>
      </div>
    </section>
  );
}